import React, {useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import Translate from "../components/Translate";

const getMaxZIndex = () => {
    const elements = [...document.querySelectorAll('body *')];
    return elements.reduce((maxZ, el) => {
        const z = window.getComputedStyle(el).zIndex;
        if (!isNaN(z)) {
            return Math.max(maxZ, Number(z));
        }
        return maxZ;
    }, 0);
};

const Tooltip = ({text, children, prefix = '', needTranslate = true}) => {
    const [visible, setVisible] = useState(false);
    const [coords, setCoords] = useState({top: 0, left: 0});
    const [zIndex, setZIndex] = useState(1000);
    const ref = useRef(null);

    const handleMouseEnter = () => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            setCoords({
                top: rect.top - 20,
                left: rect.left + rect.width / 2,
            });
            setZIndex(getMaxZIndex() + 10);
            setVisible(true);
        }
    };


    const handleMouseLeave = () => {
        setVisible(false);
    };

    return (
        <React.Fragment>
            <div
                ref={ref}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {children}
            </div>

            {visible && text &&
                createPortal(
                    <div
                        style={{
                            position: 'fixed',
                            top: coords.top,
                            left: coords.left,
                            transform: 'translateX(-50%)',
                            backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            color: 'white',
                            padding: '5px 8px',
                            borderRadius: '4px',
                            maxWidth: '300px',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            zIndex: zIndex,
                            pointerEvents: 'none',
                            userSelect: 'none',
                            fontSize: '12px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        }}
                    >
                        {needTranslate && (
                            <React.Fragment>
                                {prefix} <Translate text={text}/>
                            </React.Fragment>
                        )}
                        {!needTranslate && (
                            <React.Fragment>
                                {prefix} {text}
                            </React.Fragment>
                        )}
                    </div>,
                    document.body
                )
            }

        </React.Fragment>
    );
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components-new/Tooltip.jsx